<template>
  <div
    :class="
      fixed
        ? 'registration-actions-fixed pr-3 base'
        : 'registration-actions-sticky base'
    "
  >
    <v-col class="pa-0">
      <v-btn
        v-for="(act, index) in actions_left"
        :key="'left' + index"
        @click="act.action()"
        class="button dark dense btn-left rounded-xxl"
        :loading="act.loading"
      >
        {{ act.name }}
      </v-btn>
    </v-col>
    <v-btn
      v-for="(act, index) in actions"
      :key="index"
      @click="act.action()"
      class="rounded-lg"
      :class="
        index == 0
          ? 'button order-2 dark dense btn-right rounded-xxl'
          : 'order-1 transparent elevation-0'
      "
      :loading="loading"
      :disabled="act.disabled"
    >
      {{ act.name | uppercase }}
    </v-btn>
  </div>
</template>
<script>
/**
 * @ Registration Actions Sticky
 * @description Componente que exibe os botões de salvar e cancelar.
 * @property {Boolean} loader - Flag que indica se o botão está carregando.
 */
export default {
  name: "RegistrationActions",
  props: {
    fixed: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Principal",
    },
    subtitle: {
      type: String,
      default: "Principal",
    },
    info: {
      type: Boolean,
      default: false,
    },
    infoMessage: {
      type: String,
      default: "Message here",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    actions: {
      type: Array,
      default: () => [],
    },
    actions_left: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style scoped>
.registration-actions-sticky {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
  padding-top: 0.625rem;

  position: sticky;
  bottom: -20px;
  z-index: 1;
  background-color: #eaeaea;
}

.registration-actions-fixed {
  flex: 0 0 auto;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0.5rem;
  position: fixed;
  bottom: 0;
  left: 0;
}
</style>
